import './totalExpenses.css';

import { Pie, PieChart, Tooltip, Label } from 'recharts';
import { useEffect, useState, useMemo } from 'react';

import TimeLine from '../../timeLine/timeLine';
import SpacerBar from '../../spacerBar/spacerBar';
import BulletPoint from '../../../assets/bulletPoint/bulletPoint';

export default function TotalExpenses({loading, expenses, filteredExpenses}) {

    const [totalExpensesEntered, setTotalExpensesEntered] = useState(filteredExpenses?.[0]?.length || 0);

    const [totalAverageExpense, setTotalAverageExpense] = useState(parseFloat((filteredExpenses?.[0]?.reduce((sum, current) => sum + current?.expense_amount, 0) / filteredExpenses?.[0]?.length)).toFixed(2) || 0);

    const [totalAmountExpense, setTotalAmountExpense] = useState(parseFloat(filteredExpenses?.[0]?.reduce((sum, current) => sum + current?.expense_amount, 0)).toFixed(2) || 0);

    const [dictTime, setDictTime] = useState(0);

    
 
    const startUpTotalExpenses = useMemo(() => {
        setTotalExpensesEntered(filteredExpenses?.[0]?.length || 0);
        setTotalAverageExpense(parseFloat((filteredExpenses?.[0]?.reduce((sum, current) => sum + current?.expense_amount, 0) / filteredExpenses?.[0]?.length)).toFixed(2) || 0);
        setTotalAmountExpense(parseFloat(filteredExpenses?.[0]?.reduce((sum, current) => sum + current?.expense_amount, 0)).toFixed(2) || 0);

    }, [expenses, filteredExpenses, loading]);

    const handleTimeChange = (time) => {
        setTotalExpensesEntered(filteredExpenses?.[time]?.length || 0);
        setTotalAverageExpense(parseFloat((filteredExpenses?.[time]?.reduce((sum, current) => sum + current?.expense_amount, 0) / filteredExpenses?.[0]?.length)).toFixed(2) || 0);
        setTotalAmountExpense(parseFloat(filteredExpenses?.[time]?.reduce((sum, current) => sum + current?.expense_amount, 0)).toFixed(2) || 0);
        setDictTime(time);

    };

    const totalPie = useMemo(() => {
        const clickedValue = parseInt(totalAmountExpense) || 0;
        const totalYear = parseInt(filteredExpenses?.[3]?.reduce((sum, cur) => sum + (cur?.expense_amount || 0), 0) || 0);
    
        const percent = totalYear !== 0 ? parseInt((clickedValue / totalYear) * 100) : 0;

        if(dictTime === 3 ) {
            return [
                { time: 'this Year', value: clickedValue, fill: 'var(--secondary-color-two)', percent:  `${percent}%`}
            ]
        } else {
            return [
                { time: 'thisWeek', value: clickedValue, fill: 'var(--secondary-color-two)', percent:  `${percent}%`},
                { time: 'thisYear', value: parseInt(totalYear - totalAmountExpense), fill: '#fff' }
            ];
        }
}, [totalAmountExpense, dictTime, filteredExpenses]);

    return(
        <div>
            <div className="total-expense-container">
                <div className="total-expense-header">
                    <p>Total Expenses:</p>
                    <div><TimeLine onTimeChange={handleTimeChange}/></div>
                </div>
                <SpacerBar width='100%'/>
                <div className="total-expense-body">
                    <div className="total-expense-body-left">
                        <div className="total-expense-body-item">
                            <BulletPoint/>
                            <p>Total entered: <strong>{totalExpensesEntered}</strong></p>
                        </div>
                        <div className="total-expense-body-item">
                            <BulletPoint/>
                            <p>Average expense: <strong>${totalAverageExpense}</strong></p>
                        </div>
                        <div className="total-expense-body-item total-expense-body-item-big">
                            <div className="total-expense-body-item-big-header"><BulletPoint/><p>Total expenses:</p></div>
                            <strong>${totalAmountExpense}</strong>
                        </div>
                    </div>
                    <div className="total-expense-body-right">
                        <PieChart width={240} height={240}>
                            <Pie data={totalPie} dataKey="value" outerRadius={80} innerRadius={60} cornerRadius={100} paddingAngle={2} fill={'fill'}>
                                <Label
                                    content={({ viewBox }) => {
                                    if (viewBox && "cx" in viewBox && "cy" in viewBox) {
                                        return (
                                        <text
                                            x={viewBox.cx}
                                            y={viewBox.cy}
                                            textAnchor="middle"
                                            dominantBaseline="middle"
                                        >
                                            <tspan
                                            x={viewBox.cx}
                                            y={viewBox.cy}
                                            className="fill-foreground text-3xl font-bold"
                                            >
                                            {totalPie[0].percent}
                                            </tspan>
                                            <tspan
                                            x={viewBox.cx}
                                            y={(viewBox.cy || 0) + 24}
                                            className="fill-muted-foreground"
                                            >
                                            {`of expenses`}
                                            </tspan>
                                        </text>
                                        )
                                    }
                                    }}
                                />
                            </Pie>
                        </PieChart>
                    </div>
                </div>
            </div>
        </div>
    )
}